import { fetchToken } from "../../../common/FetchCookie";
import { BASE_URL, CANDIDATE, CANDIDATE_DETAILS_BY_PARAM, CANDIDATE_JOB_PREFERENCE, CANDIDATE_JOB_PREFERENCE_PARAM } from "../../../common/URLs";


export const fetchJobPreferences = async () => {
  const url = `${BASE_URL}/${CANDIDATE}/${CANDIDATE_DETAILS_BY_PARAM}?${CANDIDATE_JOB_PREFERENCE_PARAM}`; // Proxy path
  try {
    const token = await fetchToken()
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    // console.log("data in api", data)
    return data;
  } catch (error) {
    console.log("error", error);
  }
};

export const addJobPreference = async (newJobPreference) => {
  const url = `${BASE_URL}/${CANDIDATE}/${CANDIDATE_JOB_PREFERENCE}`; // Proxy path
  try {
    const token = await fetchToken()

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(newJobPreference),
    });
    const data = await response.json();
    console.log("API Data", data);
    return data;
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};

export const updateJobPreference = async (uuid, jobPreferenceData) => {
  try {    
    const token = await fetchToken()

    const response = await fetch(`${BASE_URL}/${CANDIDATE}/${CANDIDATE_JOB_PREFERENCE}/${uuid}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(jobPreferenceData),
    });

    // console.log("jobPreferenceData", jobPreferenceData);

    if (!response.ok) {
      throw new Error("Error updating job : " + response.statusText);
    }

    return await response.json();
  } catch (error) {
    throw new Error("Error updating job : " + error.message);
  }
};
